export default ({ Name, Address, Phone }) => {
  return (
    <div>
      <div class="flex justify-between items-center mb-3">
        <div class="user rounded-full w-16 h-16 bg-dark-gray relative flex justify-center items-center">
          <i>
            <svg
              xmlns="
http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <rect
                width="24"
                height="24"
                transform="translate(0.5)"
                fill="none"
              ></rect>
              <path
                d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21M16.5 7C16.5 9.20914 14.7091 11 12.5 11C10.2909 11 8.5 9.20914 8.5 7C8.5 4.79086 10.2909 3 12.5 3C14.7091 3 16.5 4.79086 16.5 7Z"
                stroke="#F2F4F7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              ></path>
            </svg>
          </i>
          <span class="rounded-full bg-green w-3 h-3 inline-block absolute bottom-2 right-0"></span>
        </div>
        <div>
          <div class="flex justify-between">
            <p class="text-lg font-bold">{Name}</p>
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <rect width="20" height="20" rx="10" fill="#2B3F32" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.2468 6.15838L8.28017 11.9167L6.69684 10.2251C6.40518 9.95005 5.94684 9.93338 5.61351 10.1667C5.28851 10.4084 5.19684 10.8334 5.39684 11.1751L7.27184 14.2251C7.45518 14.5084 7.77184 14.6834 8.13017 14.6834C8.47184 14.6834 8.79684 14.5084 8.98018 14.2251C9.28018 13.8334 15.0052 7.00838 15.0052 7.00838C15.7552 6.24172 14.8468 5.56672 14.2468 6.15005V6.15838Z"
                  fill="#12B76A"
                />
              </svg>
            </i>
          </div>
          <p class="phone pt-1">{Phone}</p>
          <p class="text-gray-light Address">{Address}</p>
        </div>
      </div>
      <a
        class="w-full rounded text-center bg-purple py-2 font-semibold block text-white no-underline"
        href={`tel:${Phone}`}
      >
        Call
      </a>
    </div>
  );
};
